<template>
  <div class="w-full h-full flex items-center justify-center text-gray-400">
    <icon name="Loading" size="1.5em" />
  </div>
</template>

<script>
export default {
  name: "Loading",
  data() {
    return {};
  },
  props: {},
  components: {},
  methods: {},
  computed: {},
  created() {}
};
</script>